"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTagEventsProperty = exports.tagEventsPropertyDefinition = void 0;
exports.tagEventsPropertyDefinition = {
    view: {
        label: 'Events',
        style: '',
        hint: 'Related to an event? Tag it and the asset shows on the event collection page.',
    },
    constraints: [
        {
            name: 'stencils',
            argument: ['event-profile'],
        },
    ],
    type: 'asset',
    multiple: true,
    name: 'tag-events',
};
const isTagEventsProperty = (prop) => {
    return prop.name === exports.tagEventsPropertyDefinition.name;
};
exports.isTagEventsProperty = isTagEventsProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGFnLWV2ZW50cy5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL3RhZy1ldmVudHMucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSwyQkFBMkIsR0FBRztJQUN6QyxJQUFJLEVBQUU7UUFDSixLQUFLLEVBQUUsUUFBUTtRQUNmLEtBQUssRUFBRSxFQUFFO1FBQ1QsSUFBSSxFQUFFLCtFQUErRTtLQUN0RjtJQUNELFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFVBQVU7WUFDaEIsUUFBUSxFQUFFLENBQUMsZUFBZSxDQUFDO1NBQzVCO0tBQ0Y7SUFDRCxJQUFJLEVBQUUsT0FBTztJQUNiLFFBQVEsRUFBRSxJQUFJO0lBQ2QsSUFBSSxFQUFFLFlBQVk7Q0FDYSxDQUFBO0FBSTFCLE1BQU0sbUJBQW1CLEdBQUcsQ0FBQyxJQUFrQixFQUE2QixFQUFFO0lBQ25GLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyxtQ0FBMkIsQ0FBQyxJQUFJLENBQUE7QUFDdkQsQ0FBQyxDQUFBO0FBRlksUUFBQSxtQkFBbUIsdUJBRS9CIn0=